export default __webpack_public_path__ + "static/media/foreigner_passport_icon.61b6779a.svg";